{
  "paywall": {
    "body": {
      "text": "Use Campanion to send form reminders via text with EZ Texting. Contact a CampMinder team member to learn more about this free integration."
    },
    "images": {
      "logo": "eztexting-logo-full.png",
      "screenShot": "texting-screenshot-large.png"
    }
  },
  "unauthorized": {
    "header": {
      "title": "Form Reminders",
      "description": "In order to send reminders you need to be authorized for \"Parent/Camper Communication.\"\nPlease contact your admin. Once access is granted you will need to log in again."
    },
    "images": {
      "unauthorizedImage": "unauthorized.png"
    }
  },
  "authorized": {
    "linksAndButtons": {
      "fetching": "Fetching...",
      "openEzTexting": "Open EZ Texting",
      "calculateCredits": "calculate credits",
      "send": "send",
      "eztextingUrl": "https://app.campmindertexting.com"
    },
    "errors": {
      "fetchCreditError": "We were unable to fetch your credit balance from EZ Texting. Please try again.",
      "fetchValidatedRecipientsError": "We were unable to fetch your text recipients list from EZ Texting. Please try again.",
      "sendTextsFailure": "There was an error, please try again."
    },
    "success": {
      "sendTextsSuccess": "Your message was successfully sent."
    },
    "calculateCreditsDisplay": {
      "header": "Calculate credits",
      "subHeader": "Calculate the number of credits needed to send this message.",
      "noRecipients": "No recipients meet the criteria you selected.",
      "yourCredits": "Your credits",
      "creditsNeeded": "Credits needed",
      "purchaseCredits": "Purchase more credits on EZ Texting"
    },
    "composeMessage": {
      "defaultMessageText": "You have incomplete forms! Please complete them as soon as possible.",
      "invalidOverTextLimit": "Text is over the character limit",
      "invalidSpecialCharacters": "Only the following special characters are supported: .,:;!?()=+-_/@$#&%'\"",
      "invalidNoText": "Text is required in order to send this message",
      "textPlaceholder": "Your Message Here",
      "includeLinkCheckboxLabel": "Include link to Campanion forms"
    },
    "messageSettings": {
      "noHouseholdSelected": "You must select at least one"
    }
  },
  "default": {
    "header": {
      "title": "Form Reminders",
      "description": "Send text message reminders to parents to complete forms using EZ Texting."
    }
  }
}
